import React, { useState } from "react";
import {
  Button,
  Modal,
  Form,
  Table,
  Spin,
  Row,
  Col,
} from "antd";
import IntlMessages from "../util/IntlMessages";
import ds from "../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useStore, useDispatch, useSelector } from "react-redux";
import {
  loadIsShowReturnDialog,
  loadChildData,
  loadRefundSaleStatus,
  loadIsFilterCall,
  loadFilterSaleID
} from "../appRedux/actions/Sell";
import {
  loadIsInProgress,
} from "../appRedux/actions/MainSale";

const ChildSaleDialog = (props) => {
  let curr = props.curr ? props.curr : "";
  const store = useStore();
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const [getTableData, setTableData] = React.useState([]);
  // const [isTabLoading, setTabLoading] = React.useState(true);

  const getChildData = useSelector(({ Sell }) => Sell.getChildData);
  const isShowReturnDialog = useSelector(({ Sell }) => Sell.isShowReturnDialog);
  const isFilterSaleChange = useSelector(({ Sell }) => Sell.isFilterSaleChange);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      // setTabLoading(true);
      if (getChildData && getChildData.length > 0) {
        let data = getChildData.map((a, id) => {
          let dateString = "";
          if (a.sellDate && a.sellDate != "") {
            dateString = new Date(a.sellDate);
            dateString = dateString.toLocaleString();
          }
          return {
            id: id,
            key: a.key,
            date: dateString,
            receipt: a.receipt,
            total: a.totalPrice,
            status: a.status
          }
        });
        setTableData(data);
      }
      else {
        setTableData([]);
        // setTabLoading(false);
      }
    }

    return () => mounted = false;
  }, [getChildData]);

  function contReturn(key) {
    closeDialog();
    dispatch(loadIsInProgress(true));
    dispatch(loadRefundSaleStatus(1));
    localStorage.setItem("orderGuidID", "");
    localStorage.setItem("parentOrderGuidID", key);
    history.push("/dashboard/sell/mainsale/webregister");
  }

  function closeDialog() {
    dispatch(loadIsShowReturnDialog(false));
    dispatch(loadChildData([]));
  }

  function viewSale(key) {
    closeDialog();
    dispatch(loadFilterSaleID(key));
    dispatch(loadIsFilterCall(!isFilterSaleChange));
    // history.push(
    //   `/Dashboard/sell/salehistory/sale/${key}/1`
    // );
  }

  const columns = [
    {
      title: <IntlMessages id="child.sale.col1" />,
      dataIndex: "receipt",
      key: "receipt",
      render: (text, record) => {
        return (
          <div>
            <span className="gx-link" style={{ fontWeight: "500" }}>
              <strong>{text}</strong>
            </span>
            <p>
              {record.date}
            </p>
          </div>
        );
      },
    },
    {
      title: <IntlMessages id="child.sale.col2" />,
      dataIndex: "total",
      key: "total",
      render: (text, record) => {
        return (
          <span>
            <strong>
              {`${text} ${curr}`}
            </strong>
          </span>
        );
      },
    },
    {
      title: <IntlMessages id="child.sale.col3" />,
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return (
          <span>
            <strong style={{ color: "#7a7a7a" }}>
              {text}
            </strong>
          </span>
        );
      },
    },
    {
      // title: <IntlMessages id="child.sale.tabbtn" />,
      key: "key",
      render: (text, record) => {
        return (
          <span>
            <Button
              // className="custom-addreg-btn"
              style={{ borderRadius: "1rem" }}
              type="ghost"
              onClick={() => viewSale(text.key)}
            >
              <IntlMessages id="child.sale.tabbtn" />
            </Button>
          </span>
        );
      },
    }
  ];

  return (
    <Modal
      title={
        <h2>
          <strong>
            <IntlMessages id="child.sale.popup" />
          </strong>
        </h2>
      }
      visible={isShowReturnDialog && getChildData && getChildData.length > 0}
      onCancel={() => closeDialog()}
      centered={true}
      width={"820px"}
      footer={null}
    >
      <Spin
        tip={<IntlMessages id="sell.cashlisting.cashloading" />}
        spinning={false}
        size="large"
      >
        {getChildData && getChildData.length > 0 && (
          <div>
            <Row>
              <Col span={24}>
                <h3>
                  <IntlMessages id="child.sale.desc" />
                </h3>
              </Col>
            </Row>
            {getTableData && getTableData.length > 0 && (
              <Row style={{ marginTop: 12 }}>
                <Col span={24}>
                  <Table
                    className="gx-table-responsive"
                    // loading={isTabLoading}
                    columns={columns}
                    dataSource={getTableData}
                    pagination={false}
                  />
                </Col>
              </Row>
            )}
            <Row style={{ marginTop: 22 }} gutter={12} justify="end">
              <Col>
                <Button
                  className="dk-btn-cancel"
                  type="primary"
                  onClick={() => closeDialog()}
                >
                    <IntlMessages id="child.sale.btn1" />
                </Button>
              </Col>
              <Col>
                <Button
                  className="dk-btn-add"
                  type="primary"
                  onClick={() => contReturn(getChildData[0].sParentSalesOrderID)}
                >
                    <IntlMessages id="child.sale.btn2" />
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export default ChildSaleDialog;
